import { LookupKeys } from '../models/crm/lookup.model';
import { LookupBase } from '../models/utils/lookup-base.model';
import { AssignmentTrigger } from './assignment-trigger.enum';

export const ASSIGNMENT_TRIGGER_LOOKUP: LookupBase[] = [{
  [LookupKeys.value]: AssignmentTrigger.defaultTrigger,
  [LookupKeys.description]: '-',
}, {
  [LookupKeys.value]: AssignmentTrigger.agentCreation,
  [LookupKeys.description]: 'On Agent Creation',
}];
